import { washArabic, washDetail, washFourDetail } from '@/utils/wash.js'
import { types } from '@/components/widgets/case_detail/elements.js'
const washData = (node) => {
  try {
    washDetail(node, 'case')
    if(node._type === types.four) {
      washFourDetail(node, 'case-detail-par')
    }
    washArabic(node)
  } catch (err) {
    console.log('err--', err)
  }
}
export { washData }
